import { required } from "vuelidate/lib/validators";
import messages from "@/utils/messages";
import UserService from "../../services/UserService";
export default {
  name: "Login",
  data: () => ({
    username: "",
    password: "",
    passwordMode: "password",
    passwordModeIcon: "benefits/img/eye_password.png",
  }),
  validations: {
    username: { required },
    password: { required },
  },
  components: {},
  mounted() {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message]);
    }
  },
  methods: {
    submitHandler() {
      let UserName = this.username;
      let Password = this.password;
      UserService.Authentificate(UserName, Password)
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            return res.json();
          }
        })
        .then((res) => {
          if (res.userAccountStatus == 0) {
            let user = res;
            localStorage.setItem("User", JSON.stringify(user));
            this.$router.push("/contact");
          } else if (res.userAccountStatus == 1) {
            this.$message(messages["noUser"]);
          } else if (res.userAccountStatus == 2) {
            this.$message(messages["tooManyAttempts"]);
          } else if (res.userAccountStatus == 3) {
            this.$message(messages["lockUsername"]);
          } else if (res.userAccountStatus == 4) {
            this.$message(messages["incorrectUsernameAndPassword"]);
          } else {
            this.$message(messages["technicalError"]);
          }
        });
    },
    togglePasswordMode() {
      this.passwordMode = this.passwordMode == "text" ? "password" : "text";
    },
  },
};
